import { render, staticRenderFns } from "./lottery-11X5.vue?vue&type=template&id=54444b2e&scoped=true"
import script from "./lottery-11X5.vue?vue&type=script&lang=js"
export * from "./lottery-11X5.vue?vue&type=script&lang=js"
import style0 from "./lottery-11X5.vue?vue&type=style&index=0&id=54444b2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54444b2e",
  null
  
)

export default component.exports